<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}">
        <v-form @submit.prevent="send_comment(comment)">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('add_comment_modal')">{{$t("закрыть")}}</v-icon>
            <v-card-title class="display-1 mb-4">{{$t("Оставить комментарий")}}</v-card-title>
            <v-layout mb-4>
                <v-flex xs12>
                    <textareaBase :placeholder="$t('Введите текст')" rows="4" :value="comment.text"
                                  :class="{'form-group--error': required_error}"
                                  @input="comment_text($event.target.value)"
                    />
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-layout align-center wrap>
                    <buttonRed :class="{'flex xs12 mr-0 mb-2': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}">{{$t("Отправить")}}</buttonRed>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import textareaBase from '@/components/ui/inputs/base/textarea';
import inputBase from '@/components/ui/inputs/base/input';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    textareaBase,
  },
  data() {
    return {
      required_error: false,
      comment       : {
        text: '',
      },
    };
  },
  computed: {
    ...mapGetters('news_main/detail', [
      'comments', 'new_comment',
    ]),
  },
  methods: {
    comment_text(e) {
      if (e !== '') {
        this.required_error = false;
      } else {
        this.required_error = true;
      }

      this.comment.text = e;
    },
    ...mapMutations('news_main/detail', [
      'CLOSE_MODAL',
      'TEXT_NEW_COMMENT',
      'PUSH_COMMENT',
    ]),
    ...mapActions('news_main/detail', [
      'post_news_comment', 'add_comment',
    ]),
    send_comment(comment) {
      if (this.comment.text !== '') {
        this.add_comment(comment);
        this.comment.text = '';
      } else {
        this.required_error = true;
      }
    },
  },
};
</script>
